
const Home = () => {
    return <div>Home content</div>;
  };
  export default Home;